import { gql, useMutation } from '@apollo/client'

import { cleanRequest } from './cleanRequest'
import { generalClient } from '../../../../../utils/apollo/api'
import { useModalData, useMoveBack } from '../../../../../components/modals/ModalsContext'
import { appendIf } from '@btime/helpers'
import { useNotification } from '@btime/react-messager'

const MUTATION = gql`
  mutation UpsertConfig($input: ConfigInput) {
    upsertConfig(input: $input) {
      id
    }
  }
`

const validate = (form, setErrors) => {
  const errors = [
    ...appendIf(!form.value?.days_limit, {
      path: ['value', 'days_limit'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(form.value?.filters?.distance && !form.value?.distance_radius, {
      path: ['value', 'distance_radius'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.conditions?.placeLevel?.id, {
      path: ['value', 'conditions', 'placeLevel'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(!form.value?.conditions?.placeLevelType, {
      path: ['value', 'conditions', 'placeLevelType'],
      message: 'Campo obrigatório'
    }),
    ...appendIf(form.value?.filters?.users?.type === 'selected' && !form.value?.filters?.users?.selected, {
      path: ['value', 'filters', 'users', 'selected'],
      message: 'Campo obrigatório'
    })
  ]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveConfig = () => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Config', 'Configs'],
    client: generalClient
  })
  const modalData = useModalData()
  const moveBackHistory = useMoveBack()

  const handleRequest = (form, actions) => {
    const { setErrors } = actions
    const isValid = validate(form, setErrors)
    if (isValid) {
      const input = cleanRequest(form, modalData)

      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: 'Configuração salva com sucesso!' })
          moveBackHistory()
        } else {
          notify.error({ title: `Ocorreu um erro ao salvar configuração!` })
        }
      })
    }
  }

  return [handleRequest, state]
}
